"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
// import { combineReducers } from "@reduxjs/toolkit";
var redux_1 = require("redux");
var user_1 = __importDefault(require("./slices/user"));
var main_1 = __importDefault(require("./slices/main"));
var auction_1 = __importDefault(require("./slices/auction"));
var lot_1 = __importDefault(require("./slices/lot"));
var bidder_1 = __importDefault(require("./slices/bidder"));
var console_1 = __importDefault(require("./slices/console"));
var client_1 = __importDefault(require("./slices/client"));
var scroll_1 = __importDefault(require("./slices/scroll"));
var sound_1 = __importDefault(require("./slices/sound"));
exports.reducers = (0, redux_1.combineReducers)({
    mainState: main_1.default,
    userState: user_1.default,
    auctionState: auction_1.default,
    lotState: lot_1.default,
    bidderState: bidder_1.default,
    consoleState: console_1.default,
    clientState: client_1.default,
    scrollState: scroll_1.default,
    soundState: sound_1.default,
});
